import { Dialog } from '@material-ui/core'

import * as R from 'ramda'
import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import Loading from '../../components/loading'
import config from '../../config'
import {
  ProductFormInterface,
  ProductListInterface
} from '../../interfaces/product'
import { clearProductDetail } from '../../redux/product/actions'
import { getIsFetchingProductList } from '../../redux/product/selectors'
import CompanyProductDetailForm from './CompanyProductDetailForm'
import CompanyProductListHandlerBar from './CompanyProductListHandlerBar'
import CompanyProductListTable from './CompanyProductListTable'
import CompanyProductNewForm from './CompanyProductNewForm'

const DialogFormContainer = styled.div`
  width: 500px;
  padding: 10px 15px;
`

type Props = {
  productList: ProductListInterface[]
  companyProductHandlers: {
    archiveProduct: (productId: string) => () => void
    createProduct: (createdProduct: ProductFormInterface) => void
    updateProduct: (
      productId: string
    ) => (updatedProduct: ProductFormInterface) => void
  }
}

const CompanyProductTabPanel: FC<Record<string, unknown> & Props> = ({
  productList,
  companyProductHandlers
}: Props) => {
  const dispatch = useDispatch()
  const isFetchingProductList = useSelector(getIsFetchingProductList)

  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [productId, setProductId] = useState<string>('')
  const handleCloseDialog = () => {
    dispatch(clearProductDetail())
    setOpenDialog(false)
  }
  const handleOpenProductForm = (id?: string) => () => {
    setProductId(id ?? '')
    setOpenDialog(true)
  }

  const createProductHandler = (createdProduct: ProductFormInterface) => {
    setOpenDialog(false)
    companyProductHandlers.createProduct(createdProduct)
  }

  const updateProductHandler = (updatedProduct: ProductFormInterface) => {
    setOpenDialog(false)
    companyProductHandlers.updateProduct(productId)(updatedProduct)
  }

  return (
    <>
      <CompanyProductListHandlerBar
        disabled={productList.length >= config.product.limit}
        handleOpenProductForm={handleOpenProductForm}
      />
      {isFetchingProductList ? (
        <Loading />
      ) : (
        <CompanyProductListTable
          productList={productList}
          companyProductHandlers={companyProductHandlers}
          handleOpenProductForm={handleOpenProductForm}
        />
      )}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogFormContainer>
          {/* Consider how to merge the 2 types of form together rather than seperating them apart */}
          {R.isEmpty(productId) ? (
            <CompanyProductNewForm
              createProductHandler={createProductHandler}
              handleCloseDialog={handleCloseDialog}
            />
          ) : (
            <CompanyProductDetailForm
              productId={productId}
              updateProductHandler={updateProductHandler}
              handleCloseDialog={handleCloseDialog}
            />
          )}
        </DialogFormContainer>
      </Dialog>
    </>
  )
}

export default CompanyProductTabPanel
